'use strict';

goog.provide("Ntry.Radar");

goog.require("Ntry.STATIC");

Ntry.Radar = function(radar) {
    this.left = {
        distance: 0,
        type: Ntry.STATIC.AI_METEO
    };

    this.center = {
        distance: 0,
        type: Ntry.STATIC.AI_METEO
    };

    this.right = {
        distance: 0,
        type: Ntry.STATIC.AI_METEO
    };
};

Ntry.Radar.prototype.type =
    Ntry.STATIC.RADAR;
